import {
  AppointmentCard,
  AppointmentCardProps,
  Button,
  Stack,
} from "components";
import useAppointmentStatus from "features/appointments/useAppointmentStatus";
import { useRelativeTime } from "features/appointments/useRelativeTime";

interface AppointmentCardWithButtonsProps
  extends Omit<AppointmentCardProps, "style"> {
  onEnter(): void;
  onCancel(): void;
}

const AppointmentCardWithButtons: React.FC<AppointmentCardWithButtonsProps> = ({
  startAt,
  endAt,
  status,
  doctor,
  link,
  onEnter,
  onCancel,
}) => {
  const time = useRelativeTime(new Date(startAt));
  const { isStarted, isUpcoming } = useAppointmentStatus(status);
  const isInTime = time ? time.unit === "minute" && time.value <= 15 : false;
  const canEnter = isStarted || (isUpcoming && isInTime);

  return (
    <div style={{ position: "relative" }}>
      <AppointmentCard
        startAt={startAt}
        endAt={endAt}
        status={status}
        doctor={doctor}
        link={link}
        style={{ position: "unset" }}
      />

      <Stack
        placeItems="center"
        style={{
          background: "linear-gradient(90deg, transparent, white 32px)",
          padding: "0 24px 0 48px",
          position: "absolute",
          inset: "-16px -24px -16px auto",
          zIndex: 10,
        }}
      >
        <Button size="small" color="#c62828" onClick={onCancel}>
          Cancel
        </Button>
        {canEnter && (
          <Button filled size="small" onClick={onEnter}>
            Enter
          </Button>
        )}
      </Stack>
    </div>
  );
};

export { AppointmentCardWithButtons };
